// export this to ensure any update here to be effective for all customized disclaimer banners
// which consume this style
export const getDisclaimerBannerStyle = (_, { palette = {} } = {}) => ({
  disclaimer: {
    fontSize: 12,
    color: '#323130',
    marginTop: 16,
    marginBottom: 16,
    paddingLeft: 32,
    '& span': {
      '& a.HelpTopic': {
        textDecoration: 'underline',
        color: palette.themePrimary,
        '&:focus': {
          textDecoration: 'underline',
          outline: `1px solid ${palette.neutralSecondary}`,
        },
        '&:hover': {
          textDecoration: 'underline',
          color: palette.themeDarker,
        },
      },
    },
  },
});
